if (document.readyState !== 'loading') {
    requestAnimationFrame(initSearch);
} else {
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(initSearch));
}

function initSearch() {
    const searchDrawer = document.getElementById('search-drawer');
    const storeHeader = document.querySelector('store-header');
    if (!searchDrawer || !storeHeader) {
        return;
    }
    searchDrawer.classList.remove('drawer', 'drawer--large', 'drawer--from-left');
    searchDrawer.classList.add('boa-header-search', 'hidden');
    storeHeader.after(searchDrawer);
}